// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1fzrz","skeleton-loading":"styles__skeleton-loading___397uO","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___1DY0U","skeletonText":"styles__skeletonText___c63Ob","cardSkeleton":"styles__cardSkeleton___3jn-T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/CardsOtherServicesSkeleton/styles.css
// module id = 2542
// module chunks = 0